import styled from '@emotion/styled';
import { BEPillsOwnProps } from './BEPillsProps';
import { ThemeColors } from '@theme/foundations/colors';
import { Text } from '@chakra-ui/react';

export const StyledPills = styled('div')<BEPillsOwnProps>`
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  min-width: 48px;
  gap: 2px;
  padding: 0 4px;
  padding-left: 12px;
  background-color:  ${(props) =>
    props.skin === 'attribute' ? ThemeColors.neutral['100'] : 'white'};
  color: ${(props) =>
    props.skin === 'attribute' ? ThemeColors.neutral['800'] : 'black'};
  justify-content: end;
`;

export const StyledPillsLabel = styled(Text)<{ skin: 'attribute' | 'amenity' }>`
  font-size: ${(props) => (props.skin === 'attribute' ? 12 : 14)}px;
  font-weight: ${(props) => (props.skin === 'attribute' ? 500 : 400)};
  line-height:  ${(props) => (props.skin === 'attribute' ? 16 : 24)}px;
`;
